export default __webpack_public_path__ + "static/media/logo.b4d41af7.svg";